/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LookupTypeResponseModel } from './LookupTypeResponseModel';
import {
    LookupTypeResponseModelFromJSON,
    LookupTypeResponseModelFromJSONTyped,
    LookupTypeResponseModelToJSON,
} from './LookupTypeResponseModel';

/**
 * 
 * @export
 * @interface LookupTypeCollectionResponseModel
 */
export interface LookupTypeCollectionResponseModel {
    /**
     * 
     * @type {string}
     * @memberof LookupTypeCollectionResponseModel
     */
    lookupType: string;
    /**
     * 
     * @type {string}
     * @memberof LookupTypeCollectionResponseModel
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof LookupTypeCollectionResponseModel
     */
    extendedDescription?: string;
    /**
     * 
     * @type {Array<LookupTypeResponseModel>}
     * @memberof LookupTypeCollectionResponseModel
     */
    values: Array<LookupTypeResponseModel>;
}

/**
 * Check if a given object implements the LookupTypeCollectionResponseModel interface.
 */
export function instanceOfLookupTypeCollectionResponseModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lookupType" in value;
    isInstance = isInstance && "values" in value;

    return isInstance;
}

export function LookupTypeCollectionResponseModelFromJSON(json: any): LookupTypeCollectionResponseModel {
    return LookupTypeCollectionResponseModelFromJSONTyped(json, false);
}

export function LookupTypeCollectionResponseModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupTypeCollectionResponseModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lookupType': json['LookupType'],
        'description': !exists(json, 'Description') ? undefined : json['Description'],
        'extendedDescription': !exists(json, 'ExtendedDescription') ? undefined : json['ExtendedDescription'],
        'values': ((json['Values'] as Array<any>).map(LookupTypeResponseModelFromJSON)),
    };
}

export function LookupTypeCollectionResponseModelToJSON(value?: LookupTypeCollectionResponseModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'LookupType': value.lookupType,
        'Description': value.description,
        'ExtendedDescription': value.extendedDescription,
        'Values': ((value.values as Array<any>).map(LookupTypeResponseModelToJSON)),
    };
}

